import { useForm } from '@inertiajs/react'

export default function Form({ order = {}, onSubmit }) {
  const form = useForm({
    customer_name: order.customer_name || '',
    customer_phone: order.customer_phone || '',
    customer_address: order.customer_address || '',
    total_amount: order.total_amount || '',
    status: order.status || 'pending',
    notes: order.notes || '',
  });
  const { data, setData, errors, processing } = form;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className='contents'>
      <div className='my-5'>
        <input
          type='text'
          name='customer_name'
          id='customer_name'
          placeholder='Full Name'
          value={data.customer_name}
          className='block text-gray-800 rounded-md border border-gray-400 outline-none px-3 py-2 w-full'
          onChange={(e) => setData('customer_name', e.target.value)}
          required
        />
        {errors.customer_name && (
          <div className='text-red-500 px-3 py-2 font-medium'>
            {errors.customer_name.join(', ')}
          </div>
        )}
      </div>

      <div className='my-5'>
        <input
          type='tel'
          name='customer_phone'
          id='customer_phone'
          placeholder='Phone Number (e.g 054*******)'
          value={data.customer_phone}
          className='block text-gray-800 rounded-md border border-gray-400 outline-none px-3 py-2 w-full'
          onChange={(e) => setData('customer_phone', e.target.value)}
          required
        />
        {errors.customer_phone && (
          <div className='text-red-500 px-3 py-2 font-medium'>
            {errors.customer_phone.join(', ')}
          </div>
        )}
      </div>

      <div className='my-5'>
        <input
          name='customer_address'
          id='customer_address'
          value={data.customer_address}
          placeholder='Location'
          className='block text-gray-800 rounded-md border border-gray-400 outline-none px-3 py-2 w-full'
          onChange={(e) => setData('customer_address', e.target.value)}
          required
        />
        {errors.customer_address && (
          <div className='text-red-500 px-3 py-2 font-medium'>
            {errors.customer_address.join(', ')}
          </div>
        )}
      </div>

      <input type='hidden' name='total_amount' value={data.total_amount} />

      <div className='my-5'>
        <textarea
          name='note'
          id='note'
          value={data.notes}
          placeholder='Notes (optional)'
          rows='4'
          className='block text-gray-800 rounded-md border border-gray-400 outline-none px-3 py-2 w-full'
          onChange={(e) => setData('notes', e.target.value)}
        />
        {errors.notes && (
          <div className='text-red-500 px-3 py-2 font-medium'>
            {errors.notes.join(', ')}
          </div>
        )}
      </div>

      <div className='inline'>
        <button
          type='submit'
          disabled={processing}
          className='w-full bg-[var(--color-yellow-primary)] hover:bg-[var(--color-yellow-secondary)] text-black font-bold py-2 rounded-lg shadow'
        >
          {processing ? 'Placing Order...' : 'Place Order'}
        </button>
      </div>
    </form>
  );
}
